import React from "react"
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CustomList from "../lists/CustomList"
import {useMediaQuery} from 'react-responsive'

const listData = [
    {
        text: "Desarrollador de aplicaciones web fullstack con React y Node",
        checked: true,
    },
    {
        text: "En proceso de aprender Next.js",
        checked: true,
    },
    {
        text: "Conocimientos en PHP con frameworks Laravel y Laminas",
        checked: true,
    },
    {
        text: "Desarrollador de aplicaciones de escritorio en .NET",
        checked: true,
    },
    {
        text: "Programador de tarjetas arduino",
        checked: true,
    },
    {
        text: "Base de datos en MSSQL, MySQL, PostgreSQL",
        checked: true,
    },
    {
        text: "Conocimientos en GitHub, Heroku, Fly.io",
        checked: true,
    },
    {
        text: "Conocimientos en AWS, EC2",
        checked: true,
    },
    {
        text: "Conocimientos en python utilizando Raspberry Pi",
        checked: true,
    },
]

export default function PageHome(props) {

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    return (<>
        <Stack 
            direction="column"
            alignItems="center"
            spacing={1}
            sx={{ 
                pb: 15,
                marginX: isTabletOrMobile ? 0.5 : 10
            }}
        >
            <Typography variant="h3" sx={{ mt: 2, mb: 10 }}>
                Hola, soy Ignacio Rivano.
            </Typography>
            <CustomList
                listData={listData}
            />
        </Stack>
    </>)
}